import { connect } from 'react-redux'
import UpdateProviderStatus from '../components/UpdateProviderStatus'
import { addNotifSuccess, addNotifError } from '../../notification/NotificationActions'
import { browserHistory } from 'react-router';

import { retrieveProvider, acceptedProvider, standByProvider, refusalProvider, meetingProvider, approvedProvider } from '../ProviderActions'

const mapStateToProps = (state) => {
    return {
    	provider: state.provider.provider,
    	status: state.provider.status,
    	user: state.user 
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    	onClose:(id) =>{
    		browserHistory.push('/manager/prestataire/'+id)
    	},
    	retrieveProvider: (id) => {
            return dispatch(retrieveProvider(id))
        },
        acceptedProvider: (id, network) => {
        	return dispatch(acceptedProvider(id, {network}))
        	.then(function (res) {
	          	browserHistory.push('/manager/prestataire/'+id)
	        })
	        .catch(function (err) {
	          	dispatch(addNotifError("Erreur", "Veuillez recommencer."))
	        });
        },
        standByProvider: (id, network) => {
        	return dispatch(standByProvider(id, {network}))
        	.then(function (res) {
	          	browserHistory.push('/manager/prestataire/'+id)
	        })
	        .catch(function (err) {
	          	dispatch(addNotifError("Erreur", "Veuillez recommencer."))
	        });
        },
        refusalProvider: (id, refusal_reason) => {
        	return dispatch(refusalProvider(id, {refusal_reason}))
        	.then(function (res) {
	          	browserHistory.push('/manager/prestataire/'+id)
	        })
	        .catch(function (err) {
	          	dispatch(addNotifError("Erreur", "Veuillez recommencer."))
	        });
        },
        meetingProvider: (id, rdv) => {
        	return dispatch(meetingProvider(id, rdv))
        	.then(function (res) {
	          	browserHistory.push('/manager/prestataire/'+id)
	        })
	        .catch(function (err) {
	          	dispatch(addNotifError("Erreur", "Veuillez recommencer."))
	        });
        },
        approvedProvider: (id) => {
        	return dispatch(approvedProvider(id))
        	.then(function (res) {
	          	browserHistory.push('/manager/prestataire/'+id)
	        })
	        .catch(function (err) {
	          	dispatch(addNotifError("Erreur", "Veuillez recommencer."))
	        });
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProviderStatus)



// WEBPACK FOOTER //
// ./src/provider/containers/UpdateProviderStatusContainer.js